<template>
    <div class="wrapper">
      <header class="bg">
        <h2>UED-CDN</h2>
        <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
        <p>vue-office-docx</p>
      </header>
      <section>
        <file-list :fileList="fileList"></file-list>
      </section>
    </div>
  </template>

<script>
const ur = "https://uedcdn.zto.com/static/vue-office/docx";
const versions = [
  '1.6.3'
]
export default {
  name: "index",
  data() {
    return {
      fileList: versions.map(v => ({
        label: v,
        linkList: [
          `${ur}/${v}/index.min.css`,
          `${ur}/${v}/index.min.js`
        ]
      }))
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVueofficeDocs.vue